import { render, staticRenderFns } from "./FeedbackSuccessLogout.vue?vue&type=template&id=2f7634ba&"
import script from "./FeedbackSuccessLogout.vue?vue&type=script&lang=js&"
export * from "./FeedbackSuccessLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports